<template>
  <v-col v-if="demandes">
    <v-form
      lazy-validation
      ref="formRIB"
      v-model="validFormRIB"
      @submit.prevent
      v-if="
        demandes.length == 0 || demandes[demandes.length - 1].validation != null
      "
    >
      Veuillez téléverser votre nouveau RIB (Pdf, jpeg…) :
      <v-file-input
        label="Nouveau document RIB"
        :rules="[
          (value) => !!value || 'Champ requis.',
          (value) =>
            (!!value &&
              /^.+\.(pdf|png|jpg|jpeg)$/.test(value.name.toLowerCase())) ||
            'Format incorrect. Formats acceptés : pdf, png, jpg, jpeg.',
        ]"
        accept=".pdf, .png, .jpg, .jpeg"
        v-model="RIB.nameFile"
      >
      </v-file-input>
      <v-btn
        class="mx-2"
        :disabled="!validFormRIB"
        color="success"
        @click="validerFormRIB"
        ><v-icon left>mdi-magnify</v-icon>Valider</v-btn
      >
    </v-form>

    <v-data-table v-if="demandes" :headers="headers" :items="demandes">
      <template v-slot:[`item.file`]="{ item }">
        <v-btn icon @click="afficherPDF(item)"
          ><v-icon color="green">mdi-book-open-variant</v-icon></v-btn
        >
      </template>
      <template v-slot:[`item.validation`]="{ item }">
        <v-chip v-if="item.validation == null" color="warning">
          en cours
        </v-chip>
        <v-chip v-else-if="item.validation == 0" color="error">refusé</v-chip>
        <v-chip v-else-if="item.validation == 1" color="success"
          >accepté</v-chip
        >
      </template>
      <template v-slot:[`item.messagerie`]="{ item }">
        <v-col>
          <v-badge
            :color="
              item.nombreMessagesUtilisateur <= 0 ? 'transparent' : 'primary'
            "
            :content="item.nombreMessagesUtilisateur"
          >
            <v-btn
              icon
              @click="lancerMessagerie(item)"
              :color="item.nombreMessagesUtilisateur > 0 ? 'red' : 'grey'"
              ><v-icon>chat</v-icon></v-btn
            >
          </v-badge>
        </v-col>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogPDF"
      max-width="500px"
      persistent
      transition="dialog-bottom-transition"
    >
      <BaseBlock>
        <v-row align="center" justify="center">
          <!-- <v-col align="center" justify="center" v-if="affichagePDF"> -->
          <v-responsive height="500px" width="100px">
            <iframe
              height="100%"
              width="100%"
              :src="iframeSrc"
              title="document pdf"
              style="background: #ffffff"
            ></iframe>
          </v-responsive>
        </v-row>

        <v-row justify="center">
          <v-btn
            color="error"
            @click="
              dialogPDF = false;
              iframeSrc = null;
            "
            >fermer</v-btn
          >
        </v-row>
      </BaseBlock>
    </v-dialog>

    <v-col cols="12">
      <BaseBlock title="Information RIB" v-if="messageInformation">
        <div v-html="messageInformation.message"></div>
      </BaseBlock>
    </v-col>

    <messagerie ref="messagerie" :temoinGestionnaire="false"></messagerie>
  </v-col>
</template>

<script>
import ApiRibRepository from "@/repositories/ApiRibRepository";
import ApiRefMessageRepository from "@/repositories/ApiRefMessageRepository";
import BaseBlock from "@/components/base/BaseBlock";
import messagerie from "@/components/Messagerie";

export default {
  components: {
    BaseBlock,
    messagerie,
  },
  data() {
    return {
      validFormRIB: false,
      RIB: {
        nameFile: null,
        validation: null,
      },
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Nom du fichier",
          value: "nameFile",
        },
        {
          text: "Fichier joint",
          value: "file",
        },
        {
          text: "Statut",
          value: "validation",
        },
        {
          text: "Messagerie",
          value: "messagerie",
        },
        {
          text: "Message de refus",
          value: "messageRefus",
        },
      ],
      demandes: null,
      dialogPDF: false,
      iframeSrc: null,
      messageInformation: null,
    };
  },
  async created() {
    this.demandes = await ApiRibRepository.getDemandes();
    var messageInformation = await ApiRefMessageRepository.getByType(
      "INFORMATION_RIB"
    );

    this.messageInformation =
      messageInformation != null && messageInformation.message.trim().length > 0
        ? messageInformation
        : null;
  },
  methods: {
    validerFormRIB() {
      if (this.$refs.formRIB.validate()) {
        this.$confirm(
          "<strong>ATTENTION, en validant ce dossier vous ne pourrez plus le modifier. " +
            "Cliquez sur 'Oui' pour confirmer votre demande ou sur 'Non' pour revenir à l'écran précédent.</strong>"
        ).then(async (response) => {
          if (response) {
            this.demandes.push(await ApiRibRepository.saveRIB(this.RIB));
          }
        });
      }
    },
    async afficherPDF(item) {
      this.iframeSrc = await ApiRibRepository.getDemandeFileAgent(item.id);
      this.dialogPDF = true;
    },
    lancerMessagerie(item) {
      this.$refs.messagerie.openMessagerie(item);
      item.nombreMessagesUtilisateur = 0;
    },
  },
};
</script>
